var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.543,
    height: 16.448,
    viewBox: "0 0 19.543 16.448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_513",
    "data-name": "Group 513",
    transform: "translate(468.78 -452.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M-449.278,468.654a10.974,10.974,0,0,0-1.6-6.949,11.015,11.015,0,0,0-8.139-5.171c0-.987-.015-1.94.005-2.893a1.253,1.253,0,0,0-.766-1.34,1.31,1.31,0,0,0-1.5.409q-3.558,3.536-7.139,7.049c-.13.128-.248.267-.371.4l.238-.154q3.489,3.645,6.976,7.291c.489.512.986,1.024,1.775.717.831-.323.8-1.063.783-1.788-.017-.792,0-1.585,0-2.375C-454.988,463.869-451.641,465.088-449.278,468.654Z",
    transform: "translate(0)",
    fill: "#454a65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M-449.278,468.654c-2.363-3.566-5.709-4.785-9.735-4.8,0,.79-.013,1.583,0,2.375.015.725.048,1.465-.783,1.788-.788.307-1.286-.2-1.775-.717q-3.483-3.651-6.976-7.291l-.238.154c.123-.134.242-.274.371-.4q3.571-3.523,7.139-7.049a1.31,1.31,0,0,1,1.5-.409,1.253,1.253,0,0,1,.766,1.34c-.021.953-.005,1.906-.005,2.893a11.015,11.015,0,0,1,8.139,5.171A10.974,10.974,0,0,1-449.278,468.654Z",
    transform: "translate(0)",
    fill: "#454a65"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/back.icon.3ed5b3e29c3d8ceab6beb3caf33015ea.svg";
export { ForwardRef as ReactComponent };